import { useEffect, useState } from 'react';
import { ABInfo, ABTest, ABTestEnv, ABTestOptions } from '@meitu/ab-test';
import { clientInfo } from '@meitu/pc-bridge';
import { getLocalIdentity } from '@meitu/xdesign-identity';
import getStore from '@/store';
import { isDevelopEnv } from './env';

let abTest: ABTest;
let abInfo = {} as ABInfo;

/**
 * 初始化 A/B 测试 SDK
 */
export const initABTest = async (): Promise<void> => {
    try {
        const abTestParams: ABTestOptions = {
            appKey: 'C5F34252F04B6D50',
            /** 环境变量 不传默认选择正式环境*/
            env: ABTestEnv.Release,
        };

        // 实例化 A/B 测试 SDK
        const initAbTestRef = new ABTest(abTestParams);

        await initAbTestRef.init(); // 初始化 A/B 测试 SDK

        abTest = initAbTestRef;
        abInfo = abTest.getABInfo();

        window.sessionStorage.setItem('AB_TEST_INFO', JSON.stringify(abInfo));

        // 通过埋点 SDK 设置 A/B 测试信息
        window?.mtstat?.setABInfo(abInfo);

        isInCutoutTesting();

        checkShowSvipCorner();
    } catch (error) {
        console.log('【初始化 ABTest 失败】：', error);
    }
};

/**
 * 获取 A/B 测试信息
 */
export const getAbInfo = () => {
    return window.sessionStorage.getItem('AB_TEST_INFO') || (abInfo ? JSON.stringify(abInfo) : '');
};

/**
 * 内嵌抠图实验
 * @returns
 */
// let inCutoutTesting: boolean | null = null;
export const isInCutoutTesting = () => {
    // if (clientInfo.isClient) {
    //     // 内嵌PC不做实验
    //     return false;
    // }
    return true;
    // if (abTest && inCutoutTesting !== null) {
    //     return inCutoutTesting;
    // }

    // if (abTest?.isInABTesting(22045)) {
    //     // 22045 实验组1
    //     inCutoutTesting = true;
    // } else if (abTest?.isInABTesting(22044)) {
    //     // 22044 对照版本
    //     inCutoutTesting = false;
    // } else {
    //     inCutoutTesting = false;
    // }

    // return inCutoutTesting;
};

/**
 * 付费角标实验
 */
let showSvipCorner: boolean | null = null;

export const checkShowSvipCorner = () => {
    // return false
    if (clientInfo.isClient) {
        return true;
    }
    if (abTest && showSvipCorner !== null) {
        return showSvipCorner;
    }

    if (abTest?.isInABTesting(22826)) {
        showSvipCorner = false;
    } else if (abTest?.isInABTesting(22825)) {
        showSvipCorner = true;
    } else {
        showSvipCorner = true;
    }

    return showSvipCorner;
};

// 订阅弹窗阻断实验
export const isRetentionTest = () => {
    const isVip = getStore().getState().userInfoModel.userInfo?.is_vip;

    // 会员/非个人版身份/pc内嵌环境
    if (isVip || !abTest || getLocalIdentity()?.oid || clientInfo.isClient) return false;

    if (abTest.isInABTesting(22919)) {
        // 对照组
        return false;
    } else if (abTest.isInABTesting(22920)) {
        // 实验组
        return true;
    }
};

/**
 * 是否隐藏头像实验
 */
export const isHideAvatar = async () => {
    if (!abTest) await initABTest();
    // 对照组, 保留编辑器头像
    if (abTest.isInABTesting(25243)) {
        console.log('【isHideAvatar】对照组, 保留编辑器头像');
        return false;
    }
    // 实验组, 隐藏编辑器头像
    if (abTest.isInABTesting(25244)) {
        console.log('【isHideAvatar】实验组, 隐藏编辑器头像');
        return true;
    }
    console.log('【isHideAvatar】默认不隐藏');
    return false;
};

/**
 * 是否开启deepsSeek
 */
export const isOpenDeepSeek = async () => {
    if (!abTest) await initABTest();
    // 对照组，默认开启
    if (abTest.isInABTesting(25314)) {
        console.log('【isOpenDeepSeek】对照组，默认开启');
        return true;
    }
    // 实验组，默认关闭
    if (abTest.isInABTesting(25315)) {
        console.log('【isOpenDeepSeek】实验组，默认关闭');
        return false;
    }
    console.log('【isOpenDeepSeek】默认开启');
    return true;
};

let inBrushTesting: boolean | null = null;
/**
 * 画图功能素材实验
 * https://cf.meitu.com/confluence/pages/viewpage.action?pageId=535262868
 */
export const isInBrushTest = () => {
    if (abTest && inBrushTesting !== null) {
        return inBrushTesting;
    }
    if (abTest?.isInABTesting(25591)) {
        // 对照组
        inBrushTesting = false;
    } else if (abTest?.isInABTesting(25592)) {
        // 实验组

        inBrushTesting = true;
    } else {
        inBrushTesting = false;
    }

    return inBrushTesting;
};

let inRecommendMaterialTesting: boolean | null = null;
/**
 * 自动推荐素材实验
 * https://cf.meitu.com/confluence/pages/viewpage.action?pageId=541800977
 */
export const isInRecommendMaterialTest = () => {
    if (abTest && inRecommendMaterialTesting !== null) {
        return inRecommendMaterialTesting;
    }
    if (abTest?.isInABTesting(26429)) {
        // 对照组
        inRecommendMaterialTesting = false;
    } else if (abTest?.isInABTesting(26430)) {
        // 实验组
        inRecommendMaterialTesting = true;
    } else {
        inRecommendMaterialTesting = false;
    }

    return inRecommendMaterialTesting;
};

/**
 * AB：分享按钮和下载按钮合并
 * https://cf.meitu.com/confluence/pages/viewpage.action?pageId=552208338
 */
export const checkIsInDownloadModalMergeTest = async () => {
    // 分享落地页不参与实验
    if (window.location.pathname.startsWith(isDevelopEnv() ? '/share' : '/design/share')) return false;

    if (!abTest) await initABTest();
    // 对照组
    if (abTest.isInABTesting(26192)) {
        console.log('【isInDownloadModalMergeTest】对照组, 分享按钮和下载按钮不合并');
        return false;
    }
    // 实验组
    if (abTest.isInABTesting(26193)) {
        console.log('【isInDownloadModalMergeTest】实验组, 分享按钮和下载按钮合并');
        return true;
    }
    console.log('【isInDownloadModalMergeTest】默认, 分享按钮和下载按钮合并');
    return false;
};

export const useIsInDownloadModalMergeTest = () => {
    const [is, setIs] = useState(false);
    useEffect(() => {
        checkIsInDownloadModalMergeTest().then((is) => setIs(is));
    }, []);
    return is;
};
